import {useQuery} from "@tanstack/react-query";
import {QueryKeys} from "@/Service/Api/V1/QueryKeys/QueryKeys";
import {AuthApiClient} from "@/Service/Api/V1/ApiClients/AuthApiClient";
import {ResponseError, User} from "@/Stub/V1";

export type useGetAuthUserParams = {
    enabled?: boolean
    retry?: boolean | number
};
export const useGetAuthUser = ({enabled, retry}: useGetAuthUserParams) => useQuery<User, ResponseError>({
    ...QueryKeys.auth.user,
    queryFn: async () => await AuthApiClient.getAuthUser(),
    enabled,
    retry
});